<mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
  <mat-expansion-panel-header>
    <mat-panel-title> Table Visualization </mat-panel-title>
    <mat-panel-description> {{ tableVisualization.name }}</mat-panel-description>
  </mat-expansion-panel-header>
  <form [formGroup]="filterColumns" (ngSubmit)="onSubmit()">
    <div class="filter-container">
      @for (column of tableVisualization.columnCsvList; track column.id) { @if (column.filterable) {
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ column.name }} </mat-label>
        <input matInput type="text" [formControlName]="column.name" placeholder="Enter your value" />
      </mat-form-field>
      } }
      <button class="filter-search-icon" type="submit" mat-raised-button color="primary"><mat-icon>search</mat-icon></button>
    </div>
  </form>

  <div class="table-container">
    <mic-spinner-overlay color="primary" [loading]="paginationSpinner">
      <div class="table-scroll-wrapper" micScrollBar [micScrollBarOptions]>
        <mic-table class="table-stripped" [config]="tableConfig" [dataSource]="dataSource">
          <ng-container *micTableColumnSelector>
            <button class="column-selector-fixed" mat-flat-button><mat-icon>view_column</mat-icon> Columns</button>
          </ng-container>

          @for (item of tableVisualization.columnCsvList; track item.name) {
          <ng-container *micCellTemplate="let tableRow; name: item.name">
            <input
              class="input-table-holder dark-mode-input dark-mode mat-cell"
              [id]="item.name + '-' + tableRow[idKey] + '-' + onWhereclause(tableRow)"
              type="text"
              [value]="tableRow[item.name]"
              [size]="getInputDisplaySize(tableRow[item.name])"
              [title]="tableRow[item.name]"
              (change)="onChange($event, tableRow, item.name)"
            />
          </ng-container>
          }
        </mic-table>
      </div>
    </mic-spinner-overlay>

    <mat-paginator
      [length]="length"
      [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 25, 100]"
      (page)="onPageChange($event)"
      aria-label="Select page"
    >
    </mat-paginator>
    <button (click)="onUpdateData()" mat-flat-button>Save</button>

    @if (this.user['role'] === 'Admin') {
    <div>
      <button (click)="onUpdateSettings()" mat-flat-button><mat-icon>settings</mat-icon></button>
      <button (click)="onDelete()" class="deleteGroup" mat-flat-button color="warn">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    }
  </div>
</mat-expansion-panel>
